import { createReducer, on } from '@ngrx/store';
import { ActionBar } from '../../models';
import * as pageActions from '../actions/action-bars.action';
import * as utility from '../../../utility';

export interface ActionBarsState {
  entities: { [id: number]: ActionBar };
  loaded: boolean;
  loading: boolean;
  error?: any;
}

export const initialState: ActionBarsState = {
  entities: {},
  loaded: false,
  loading: false,
};

export const ActionBarReducer = createReducer(
  initialState,
  on(pageActions.LoadActionBars, (state: ActionBarsState) => {
    return {
      ...state,
      loading: true,
    };
  }),
  on(pageActions.LoadActionBarsSuccess, (state: ActionBarsState, { bars }) => {
    const entities = utility.ToEntities(bars, 'id', state.entities);
    return {
      ...state,
      entities,
      loading: false,
      loaded: true,
    };
  }),
  on(pageActions.LoadActionBarsFail, (state: ActionBarsState, { error }) => {
    return {
      ...state,
      loading: false,
      loaded: false,
      error,
    };
  })
);

export const getActionBarsEntities = (state: ActionBarsState) => state.entities;
export const getActionBarsLoading = (state: ActionBarsState) => state.loading;
export const getActionBarsLoaded = (state: ActionBarsState) => state.loaded;
